import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { b2bLocalePt } from "../layouts/B2B/i18n";
import { premiumLocalePt } from "../layouts/Premium/i18n";
import { HOME_USER_LAST_ACTIVITY_TRANSLATION_KEY } from "./constants";
export default {
  pt: /*#__PURE__*/_defineProperty({}, HOME_USER_LAST_ACTIVITY_TRANSLATION_KEY, /*#__PURE__*/_objectSpread(/*#__PURE__*/_objectSpread({
    // MyActiveDegree DegreeCard
    DEGREE_START_LABEL: 'Início das aulas',
    DEGREE_COURSE_COUNT: '{{count}} curso',
    DEGREE_COURSE_COUNT_plural: '{{count}} cursos',
    // MyActiveDegree Events
    NEXT_LIVE_DEGREE_EVENT: 'Seu próximo evento importante...',
    SEE_ALL_DEGREE_EVENTS: 'Ver todos os eventos',
    SCHEDULE_DEGREE_EVENT: 'Adicionar ao calendário',
    SCHEDULE_DEGREE_EVENT_AGAIN: 'Agendar novamente',
    GO_TO_DEGREE_COMPLEMENTARY_SESSION: 'Ir à sessão',
    GO_TO_DEGREE_COUNSELLING: 'Ir ao assessoramento',
    GO_TO_DEGREE_KICKOFF: 'Ir ao onboarding',
    GO_TO_EXTERNAL_SESSION: 'Ir ao zoom',
    DEGREE_EVENT_DIALOG_TITLE: 'Calendário acadêmico',
    DEGREE_EVENT_DIALOG_DESC: 'Aqui você irá encontrar a agenda de todos os próximos eventos importantes que serão realizados durante seu MicroDegree.',
    BOOTCAMP_EVENT_DIALOG_DESC: 'Aqui você irá encontrar a agenda de todos os próximos eventos importantes que serão realizados durante seu Bootcamp.',
    // MyActiveDegree Features
    DEGREE_SLACK_TITLE: 'Interaja com outros alunos do MicroDegree',
    BOOTCAMP_SLACK_TITLE: 'Interaja com outros alunos do Bootcamp',
    DEGREE_SLACK_LINK: 'Abrir Slack',
    BOOTCAMP_CHAT_LINK: 'Abrir Discord',
    DEGREE_ATTACHMENTS_TITLE: 'Esclareça as suas dúvidas com nossos guias do MicroDegree',
    BOOTCAMP_ATTACHMENTS_TITLE: 'Esclareça as suas dúvidas com nossos guias do Bootcamp',
    DEGREE_ATTACHMENTS_LINK: 'Baixar guias',
    DEGREE_UNAVAILABLE_LINK: 'Em breve',
    DEGREE_ATTACHMENTS_DIALOG_TITLE: 'Baixe aqui os guias de apoio',
    // NewCoursesSlider
    NEW_COURSES_SLIDER_TITLE: 'A Crehana tem o curso ideal para você. Conheça nossos lançamentos.',
    NEW_COURSE_TAG: 'Novo',
    // BannerPremiumTrial
    PREMIUM_TRIAL_BANNER_TITLE: 'Comece a desfrutar do Premuim grátis por 24 horas.',
    PREMIUM_TRIAL_BANNER_DESCRIPTION: 'Deixamos algumas recomendações de acordo com seus interesses, para que você possa começar hoje mesmo a aprender.',
    PREMIUM_COUPON_TRIAL_BANNER_TITLE: 'Escolha o seu primeiro curso e comece a experiência Premuim hoje!',
    PREMIUM_COUPON_TRIAL_BANNER_DESCRIPTION: 'Deixamos algumas recomendações de acordo com seus interesses, para que você possa começar hoje mesmo a aprender.',
    PREMIUM_COUPON_TRIAL_DIALOG_TITLE: 'Parabéns, {{name}} Você tem acesso por {{count}} dia à Crehana Premium!',
    PREMIUM_COUPON_TRIAL_DIALOG_TITLE_plural: 'Parabéns, {{name}} Você tem acesso por {{count}} dias à Crehana Premium!',
    PREMIUM_COUPON_TRIAL_DIALOG_DESCRIPTION: 'Escolha seu primeiro curso e comece a aprender hoje',
    PREMIUM_COUPON_TRIAL_DIALOG_CTA: 'Vamos começar',
    // MyCourses CourseEnrollments
    BOTTOM_COURSES_TITE: 'Cursos vistos recentemente',
    SIDE_COURSES_TITE: 'Seus cursos',
    B2B_SIDE_COURSES_TITLE: 'Cursos atribuídos a você',
    COURSES_FILTER_LABEL: 'Filtrar por',
    COURSES_FILTER_ALL: 'Recentes',
    COURSES_FILTER_ASSIGNED: 'Cursos atribuídos',
    HE_SIDE_COURSES_TITLE: 'Cursos na minha rota',
    COURSES_FILTER_INITIAL: 'Para começar',
    COURSES_FILTER_PROGRESS: 'Em andamento',
    COURSES_FILTER_COMPLETED: 'Concluídos',
    PROGRESS_COURSES_EMPTY_TITLE: 'Em breve você receberá novas atribuições',
    PROGRESS_COURSES_EMPTY_DESC: 'Entre em contato com seu administrador',
    COMPLETED_COURSES_EMPTY_TITLE: 'Você ainda não completou nenhum curso',
    COMPLETED_COURSES_EMPTY_DESC: 'Lembre-se de que para obter o seu certificado Crehana, você deve completar todas as aulas e apresentar o seu projeto final!',
    ASSIGNED_COURSES_EMPTY_TITLE: 'Ainda não foram atribuídos cursos a você',
    ASSIGNED_COURSES_EMPTY_DESC: 'Entre em contato com o administrador da sua empresa para iniciar seu aprendizado.',
    USER_DASHBOARD_CTA_TITLE: 'Não consegue encontrar seu curso aqui?',
    SEE_ALL_MY_COURSES: 'Ver todos os meus cursos',
    // MyCourses RecommendedCourses
    RECOMMENDED_LIST_TITLE: 'Recomendamos os seguintes cursos a você',
    RECOMMENDED_LIST_CTA_TITLE: 'Siga em frente, vamos lá!\nMelhore outras habilidades criativas.',
    // MyCourses ReferralLinkBlock
    REFERRAL_LINK_TITLE: 'RECOMENDE O PREMUIM E RECEBA 6 MESES ADICIONAIS DE GRAÇA',
    REFERRAL_LINK_BUTTON: 'RECOMENDE SEUS AMIGOS',
    // ErrorMessage
    COURSES_ERROR: 'Ocorreu um erro ao obter seus cursos.',
    NEW_COURSES_ERROR: 'Ocorreu um erro ao obter os novos cursos.',
    RECOMMENDED_COURSES_ERROR: 'Ocorreu um erro ao obter seus cursos recomendados.',
    /* Not supported for Brazil */
    DEGREE_ERROR: 'Ocorreu um erro ao obter informação sobre seu MicroDegree',
    BOOTCAMP_ERROR: 'Ocorreu um erro ao obter informação sobre seu Bootcamp',
    TRY_AGAIN: 'Tente novamente',
    // Common actions
    GO_TO_CATALOG: 'Ir ao catálogo',
    GO_TO_USER_DASHBOARD: 'Ir a meus cursos',
    SEE_ALL_COURSES: 'Ver todos os cursos',
    GO_TO_BOOTCAMP: 'Ir ao bootcamp',
    SEE_COURSE_DETAILS: 'Ver detalhes',
    ADD_INTERESTS: 'Adicionar interesses',
    EDIT_INTERESTS: 'Editar meus interesses',
    // PROJECT CARD
    // TODO: Translate to pt
    START_PROJECT: 'Comece o projeto',
    EDIT_PROJECT: 'Editar projeto',
    MATERIAL: 'Material',
    GO_TO_PROJECT: 'Veja meu projeto',
    YOUR_LAST_PROJECT: 'Seu último projeto',
    IT_IS_TIME_TO_CREATE_PROJECT: 'Comece seu projeto do curso:',
    IT_IS_TIME_TO_CREATE_PROJECT_MOBILE: 'Inicia tu proyecto final del curso',
    DOWLOAD_MATERIAL: 'Baixar material',
    WATCH_TUTORIAL: 'Veja o tutorial',
    FINAL_PROJECT: 'Projeto final',
    FINAL_PROJECT_DESCRIPTION: 'Inicie seu projeto final de curso e obtenha a certificação',
    TEMPLATES: 'Modelos',
    FINAL_PROJECT_QUESTION: 'Não sabe como iniciar o projeto final do curso?',
    DOWNLOAD_TEMPLATE_AND_START_PROJECT: 'Baixe o modelo e comece seu projeto final',
    HOW_TO_UPLOAD_PROJECT_TEXT: 'Vamos te contar em etapas como fazer upload de seus projetos',
    ORGANIZE_FINAL_PROJECT_WITH_TEMPLATE: 'Organize seu projeto final seguindo este modelo',
    TUTORIAL_TO_UPLOAD_PROJECT_TEXT: 'Neste tutorial, vamos contar a você todas as funções do upload do projeto',
    FOLLOW_TEMPLATE_STEPS: 'Siga as etapas do modelo e organize seu projeto final',
    PROJECT_EMPTY_TITLE: 'Projeto sem título',
    PROJECT_UPDATED_AT: 'Última atualização {{date}}',
    COMPLETE_FINAL_EXAM: 'Complete o exame final',
    GO_TO_FINAL_EXAM: 'Vá para o exame',
    SIDE_EMPTY_VIEW_TITLE: 'Em breve você terá mais cursos atribuídos',
    SIDE_EMPTY_VIEW_ALL_CATALOG_DESC: 'Enquanto isso, descubra todo o nosso conteúdo de acordo com seus interesses',
    SIDE_EMPTY_VIEW_ALL_CATALOG_CTA: 'Visualize o conteúdo para você',
    SIDE_EMPTY_VIEW_ONLY_PANEL_DESC: 'Entre em contato com seu administrador',
    MENTOR_CARD_TITLE: 'Tutor'
  }, premiumLocalePt.pt), b2bLocalePt.pt))
};